import { MemberProps } from 'app/components/Core/convention'
import * as React from 'react'

const PrentId: React.FC<MemberProps<IInvoiceItem>> = ({ member }) => {
  if (member.__typename === 'InvoiceItem' && member.lineItem?.lineItemId) {
    return <>{member.lineItem.lineItemId} </>
  }

  return '-'
}

export default PrentId
